/**
 * Absences-Konstanten und Helfer.
 * Aus Absences.jsx extrahiert.
 */
import { UserX, Baby, Heart, AlertCircle } from 'lucide-react';

export const ABSENCE_TYPES = [
  { value: 'K', label: 'Krankheit', short: 'K', icon: UserX, color: 'bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-200' },
  { value: 'KK', label: 'Kind krank', short: 'KK', icon: Baby, color: 'bg-orange-100 text-orange-800 dark:bg-orange-900/40 dark:text-orange-200' },
  { value: 'EZ', label: 'Elternzeit', short: 'EZ', icon: Heart, color: 'bg-purple-100 text-purple-800 dark:bg-purple-900/40 dark:text-purple-200' },
  { value: 'KO', label: 'Krank ohne Krankenschein', short: 'KO-Tag', icon: AlertCircle, color: 'bg-rose-100 text-rose-800 dark:bg-rose-900/40 dark:text-rose-200' },
];

export const getAbsenceType = (type) =>
  ABSENCE_TYPES.find((t) => t.value === type) || ABSENCE_TYPES[0];

// Bescheinigungs-Typen fuer Krankheit (K).
// eAUB = elektronische Arbeitsunfaehigkeitsbescheinigung (Krankenkasse digital).
// AUB  = papierhaftes Original vom Mitarbeiter.
// none = nicht vorhanden / noch offen.
export const CERTIFICATE_TYPES = [
  { value: 'eAUB', label: 'eAUB (elektronisch)', short: 'eAUB', color: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-200' },
  { value: 'AUB', label: 'AUB (Papier)', short: 'AUB', color: 'bg-sky-100 text-sky-800 dark:bg-sky-900/40 dark:text-sky-200' },
  { value: 'none', label: 'Noch offen', short: 'offen', color: 'bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-200' },
];

export const getCertificateType = (value) =>
  CERTIFICATE_TYPES.find((t) => t.value === value) || null;

export const emptyAbsenceForm = {
  employee_id: '',
  start_date: '',
  end_date: '',
  absence_type: 'K',
  notes: '',
  doctor_note: false,
  doctor_note_date: '',
  employer_confirmation: false,
  child_sick_certificate: false,
  certificate_type: '',
  attachments: [],
};
